import React, { useEffect, useState } from "react";
import "rc-dropdown/assets/index.css"; // Import the default styles
import styles from "./notification.module.css"; // Import your CSS module
import NotificationDropdown from "common/RcDropDown";
import { getAll } from "utils/queries";
import { useNavigate } from "react-router-dom";

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [count, setTotalCount] = useState(0);
  const navigate = useNavigate()

  const getResults = async () => {
    try {
      const results = await getAll("notifications/notifications?offset=0&limit=5", false);
      if (results) {
        setNotifications(
          results?.data?.data?.rows?.map((e) => ({
            name: e?.firstname + e?.lastname,
            ...e,
          }))
        );
        setTotalCount(results?.data?.data?.count)
      }
    } catch (error) {}
  };

  useEffect(() => {
    getResults();
  }, []);

  const menu = () =>{

     
    return <div className={styles.notificationDropdown}>
      {notifications?.length ? (
        notifications.map((notification) => (
          <div key={notification.id} className={styles.notificationItem}>
            {notification?.message}
          </div>
        )
      )
      ) : (
        <div className={styles.noNotifications}>No notifications</div>
      )}
      {notifications?.length && <div className={styles.viewAll} onClick={()=>navigate("/notifications")}> {`View All (${count})`} </div>}
    </div>

}


  const comp = (
    <img src={`/icons/bell.svg`} alt="bell image" className={styles.bellIcon} />
  );
  return (
    <NotificationDropdown
      data={notifications}
      childComp={comp}
      renderFunc={menu}
    />
  );
};

export default Notifications;
